// src/components/BottomNav.js
import React, { useContext } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const BottomNav = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const baseClasses =
    'flex-1 flex flex-col items-center justify-center text-[10px]';
  const activeClasses = 'text-app-accent';
  const inactiveClasses = 'text-app-text-secondary-light dark:text-app-text-secondary';

  // Kiosk users get a different navigation
  if (user && user.role === 'kiosk') {
    const isHomeActive = location.pathname === '/kiosk';

    const handleHomeClick = () => {
      // Navigate to home with replace option to clear history state
      navigate('/kiosk', { replace: true });
    };

    return (
      <nav className="lg:hidden h-14 border-t border-app-nav-border-light dark:border-app-nav-border bg-app-nav-light/95 dark:bg-app-nav/80 backdrop-blur flex text-xs z-10">
        <button
          onClick={handleHomeClick}
          className={`${baseClasses} ${isHomeActive ? activeClasses : inactiveClasses}`}
        >
          <span>🏠</span>
          <span>Home</span>
        </button>

        <NavLink
          to="/kiosk/book"
          className={({ isActive }) =>
            `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`
          }
        >
          <span>🚗</span>
          <span>Book</span>
        </NavLink>

        <NavLink
          to="/kiosk/search"
          className={({ isActive }) =>
            `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`
          }
        >
          <span>🔍</span>
          <span>Search</span>
        </NavLink>

        <NavLink
          to="/kiosk/profile"
          className={({ isActive }) =>
            `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`
          }
        >
          <span>👤</span>
          <span>Profile</span>
        </NavLink>
      </nav>
    );
  }

  // Default navigation for customer, dealer_admin, dealer_staff, and admin roles
  return (
    <nav className="lg:hidden h-14 border-t border-app-nav-border-light dark:border-app-nav-border bg-app-nav-light/95 dark:bg-app-nav/80 backdrop-blur flex text-xs z-10">
      <NavLink
        to="/vehicles"
        className={({ isActive }) =>
          `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`
        }
      >
        <span>🏠</span>
        <span>Vehicles</span>
      </NavLink>

      {/* Hide Favorites and Appointments for dealer users */}
      {(!user || (user.role !== 'dealer_admin' && user.role !== 'dealer_staff')) && (
        <>
          <NavLink
            to="/favorites"
            className={({ isActive }) =>
              `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`
            }
          >
            <span>⭐</span>
            <span>Favorites</span>
          </NavLink>

          <NavLink
            to="/appointments"
            className={({ isActive }) =>
              `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`
            }
          >
            <span>📅</span>
            <span>Appointments</span>
          </NavLink>
        </>
      )}

      {/* Admin tab */}
      {user && user.role === 'admin' && (
        <NavLink
          to="/admin/dealers"
          className={({ isActive }) =>
            `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`
          }
        >
          <span>🛠️</span>
          <span>Admin</span>
        </NavLink>
      )}

      {/* Dealer tab - for dealer_admin and dealer_staff */}
      {user && (user.role === 'dealer_admin' || user.role === 'dealer_staff') && (
        <NavLink
          to="/dealer"
          className={({ isActive }) =>
            `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`
          }
        >
          <span>🏢</span>
          <span>Dealer</span>
        </NavLink>
      )}

      <NavLink
        to="/profile"
        className={({ isActive }) =>
          `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`
        }
      >
        <span>👤</span>
        <span>Profile</span>
      </NavLink>
    </nav>
  );
};

export default BottomNav;
